module.exports = "<fa style=\"font-size: 30px;\" name=\"shopping-cart\"></fa>\n<a style=\"margin-bottom: 25px;\" href=\"#\" class=\"badge badge-info\">{{itemsCount}}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cart/cart.component.html
// module id = ./src/app/cart/cart.component.html
// module chunks = main